import { Middleware } from '@nuxt/types';

const enforceOrganizationMembershipMiddleware: Middleware = context => {
  if (!context.$auth.$state.loggedIn) {
    // "auth" middleware will enforce this
    return;
  }

  if (!context.route.params.id) {
    // not on an organization page
    return;
  }

  const isUserOrganizationMember = context.store.getters['settings/isOrganizationMember'](context.route.params.id);

  if (!isUserOrganizationMember) {
    const errorMessage = context.app.i18n.t('shared.error.server_validation.authorization_error');
    context.app.$toast.error(errorMessage);
    context.$auth.redirect('home');
  }
};

export default enforceOrganizationMembershipMiddleware;
